const pageToActionNameMap = {
  businessCardsV2: 'vac',
  businessHome: 'b2b',
  businessPDP: 'pdp'
};
export default pageToActionNameMap;
